<script lang="ts">
  import { formatLakAmountValue } from '@/components/appDriver/wallet/utils'

  export let amount: number
  export let symbol = '₭'
  export let absolute = false
</script>

<span class="inline-flex items-baseline">
  <span class="mr-0.5 text-[0.75em] leading-none">{symbol}</span>
  <span>{formatLakAmountValue(amount, { absolute })}</span>
</span>
